export const abnDeclarationMessage = 'I declare that I own, or am registering the company for the owner(s) of the identical business name(s), the registration details of which are listed.';
